<template>
  <div class="service detail wrap">
    <div class="text-bg keycloak">
      <div class="text-wrap">
        <p>{{ $t('service.detail.keycloak.lineText.01') }}</p>
        <p>{{ $t('service.detail.keycloak.lineText.02') }}</p>
        <p>{{ $t('service.detail.keycloak.lineText.03') }}</p>
      </div>
    </div>
    <HalfPageLayout class="keycloak title">
      <template #half-left>
        <div class="img keycloak"></div>
      </template>
      <template #half-right>
        <div class="inner-contents">
          <div class="contents-title">
            <h3 style="line-height: 1.1">
              {{ $t('service.title.keycloak') }}
            </h3>
            <h6>Open Source Single Sign-On Solution</h6>
            <h4>{{ $t('service.detail.keycloak.subTitle') }}</h4>
          </div>
          <h5>{{ $t('service.detail.keycloak.desc') }}</h5>
        </div>
      </template>
    </HalfPageLayout>
    <HalfPageLayout class="keycloak summary bg-light">
      <template #half-left>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('service.detail.keycloak.firstPage.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:key-thin"></Icon>
              <dl>
                <dt>{{ $t('service.detail.keycloak.firstPage.contents.01.title') }}</dt>
                <dd>{{ $t('service.detail.keycloak.firstPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1000">
              <Icon icon="ph:lock-open-thin"></Icon>
              <dl>
                <dt>{{ $t('service.detail.keycloak.firstPage.contents.02.title') }}</dt>
                <dd>{{ $t('service.detail.keycloak.firstPage.contents.02.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1500">
              <Icon icon="ph:shield-check-thin"></Icon>
              <dl>
                <dt>{{ $t('service.detail.keycloak.firstPage.contents.03.title') }}</dt>
                <dd>{{ $t('service.detail.keycloak.firstPage.contents.03.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
      <template #half-right>
        <div class="img visual-01"></div>
      </template>
    </HalfPageLayout>
    <HalfPageLayout class="keycloak summary">
      <template #half-left>
        <div class="img visual-02"></div>
      </template>
      <template #half-right>
        <div class="animation-bg">
          <div class="gear"><SvgGear /></div>
          <div class="gear"><SvgGear /></div>
        </div>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('service.detail.keycloak.secondPage.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:plugs-connected-thin"></Icon>
              <dl>
                <dt>{{ $t('service.detail.keycloak.secondPage.contents.01.title') }}</dt>
                <dd>{{ $t('service.detail.keycloak.secondPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1000">
              <Icon icon="ph:gear-six-thin"></Icon>
              <dl>
                <dt>{{ $t('service.detail.keycloak.secondPage.contents.02.title') }}</dt>
                <dd>{{ $t('service.detail.keycloak.secondPage.contents.02.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1500">
              <Icon icon="ph:cloud-thin"></Icon>
              <dl>
                <dt>{{ $t('service.detail.keycloak.secondPage.contents.03.title') }}</dt>
                <dd>{{ $t('service.detail.keycloak.secondPage.contents.03.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
    </HalfPageLayout>
    <section class="section keycloak benefit">
      <h2 class="hl section-title">{{ $t('service.detail.keycloak.benefit.title') }}</h2>
      <div class="section-contents">
        <div class="benefit-grid inner-contents">
          <div
            v-for="(item, key) in $tm('service.detail.keycloak.benefit.contents')"
            :key="key"
            class="benefit-card"
            data-aos="fade-up"
          >
            <dt>{{ item.title }}</dt>
            <dd>{{ item.desc }}</dd>
          </div>
        </div>
        <router-link to="/contact" class="button big line">
          {{ $t('service.detail.contact') }}
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import HalfPageLayout from '@/components/HalfPageLayout'
import { Icon } from '@iconify/vue'
import SvgGear from '@/components/SvgGear'

export default {
  name: 'ServiceDetailKeycloak',
  components: { SvgGear, HalfPageLayout, Icon }
}
</script>

<style scoped>
</style>
